'use client';

import React from 'react';
import { Flex, Link, Logo, Box } from '@shared/ui';
import i18n from '@shared/i18n';

export const BackToPanel = () => {
    return (
        <Flex backgroundColor="neutral.020" justifyContent="center" alignItems="center">
            <Link
                href="/panel"
                p="10px"
                display="inline-flex"
                alignItems="center"
                gap="6px"
                color="dynamic.040"
                fontWeight="medium"
                letterSpacing="0.14px"
            >
                <Box w="17px">
                    <Logo.PinzapSymbol />
                </Box>
                {i18n.gettext('回到 Pinzap 商店後台')}
            </Link>
        </Flex>
    );
};
